export default __webpack_public_path__ + "static/ClientScrollBgDark-9d91692ab0338e281ca2591494a2d1ad.png";